var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"textField",attrs:{"label":_vm.label,"rules":[_vm.rules.required],"disabled":_vm.fieldIsLocked,"prepend-icon":_vm.fieldIcon,"suffix":_vm.unit},on:{"keyup":_vm.updateFieldErrors,"change":_vm.updateFieldErrors},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }